import { Exam } from "./exam";
import { SelectedExams } from "./selected-exams";
export class AvailableExams {
    constructor() {
        this.examsByCertificate = {};
        this.availableExamsInputs = $("#available-exams .exam");
        this.selectedExams = new SelectedExams();
        this.createExams();
    }
    getExamsForCertificateId(certificateId) {
        if (this.examsByCertificate[certificateId] === undefined) {
            this.examsByCertificate[certificateId] = [];
        }
        return this.examsByCertificate[certificateId];
    }
    createExams() {
        this.availableExamsInputs.each((index, element) => {
            const exam = new Exam($(element));
            this.getExamsForCertificateId(exam.certificate.id).push(exam);
            exam.price.changedCallback = () => this.selectedExams.onAvailablePriceChanged(exam);
            exam.price.init();
        });
    }
    showCertificateExams(certificateId) {
        this.availableExamsInputs.css("display", "none");
        const exams = [];
        for (const exam of this.getExamsForCertificateId(certificateId)) {
            exam.visible = true;
        }
    }
    removeSelectedExams() {
        this.selectedExams.removeAll();
    }
}
